<template>
    <div
        :class="`${classname}-mobile-card-wrapper`"
        :data-referindex="index"
        :data-id="id"
    >
        <div :class="`${classname}-mobile-card`">
            <div class="card-header">
                <slot name="cardheadercontent"></slot>
            </div>

            <div class="card-body">
                <slot name="cardbodycontent"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CardElement",
    props: {
        classname: {
            type: String,
            required: true,
        },
        index: {
            type: Number,
            required: false,
        },
        id: {
            type: Number,
            required: false,
        },
    },
};
</script>
